// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"1539":"c06bf4f1","2267":"cd0f44c1","8382":"38115183"}[chunkId] + ".iframe.bundle.js";
};